import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { TokenStorageService } from '../auth/token-storage.service';

/**
 * MsalInterceptor tries to silently acquire an Azure token for every request matching its
 * protectedResourceMap; with zero MSAL accounts (an OTP-only session) that silent acquisition
 * always fails and MsalInterceptor reacts by redirecting the browser to Microsoft login —
 * for every API call, not just the auth endpoints. An active OTP session must bypass
 * MsalInterceptor entirely so its own bearer token (attached by otpAuthInterceptor) is used as-is.
 */
export const msalGateInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  if (tokenStorage.hasSession()) {
    return next(req);
  }

  const msalInterceptor = inject(MsalInterceptor);
  return msalInterceptor.intercept(req, { handle: next });
};
